import React, { useEffect } from 'react';
import { Check } from 'lucide-react';

const SubscriptionComplete: React.FC = () => {
  useEffect(() => {
    try {
      window.parent.postMessage({ type: 'payment-complete' }, window.location.origin);
    } catch {}
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-rs-off-black px-6 text-center">
      <div className="bg-rs-jet border border-rs-green/30 rounded-2xl p-10 max-w-sm w-full">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-rs-green/15 mx-auto mb-5">
          <Check size={32} className="text-rs-green" />
        </div>
        <h1 className="text-2xl font-semibold text-rs-off-white mb-2">Payment received</h1>
        <p className="text-rs-off-white/60 text-sm">
          Your subscription is being activated. This window will close shortly.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionComplete;
